import { OutlinedInput } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ValidatedInputProps as Props } from './types';

export const ValidatedInput = memo(
  ({
    className,
    fieldLabel,
    placeholder,
    defaultValue = '',
    validator,
    onChange,
    ...other
  }: Props) => {
    const [value, setValue] = useState(defaultValue);
    const [errorMsg, setErrorMsg] = useState<string | null>(null);
    const [change, setChange] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const v = e.target.value;
      setValue(v);
      if (!change && v !== defaultValue) {
        setChange(true);
        onChange?.();
      }
    };

    return (
      <Styled.Wrapper
        className={classnames('ValidatedInput', className)}
        sx={SX.root}
      >
        <Typography variant="body4" color="grey.500" fontWeight={400}>
          {fieldLabel}
        </Typography>
        <OutlinedInput
          {...other}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={() => setErrorMsg(validator(value))}
          error={!!errorMsg}
          helperText={errorMsg ?? undefined}
        />
      </Styled.Wrapper>
    );
  }
);

ValidatedInput.displayName = 'ValidatedInput';
